module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('rt-lookup', _vm._b({
    attrs: {
      "fetch": _vm.getLookUpDataList,
      "value": _vm.lookupValue,
      "display-fields": _vm.dialogDisplayFields,
      "alias": _vm.defaultAlias,
      "allow-input": _vm.allowInput
    },
    on: {
      "input": _vm.handleDataSelected,
      "change": _vm.handleDataChange
    }
  }, 'rt-lookup', _vm.$attrs, false))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-322c30da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/lookup/src/lookup2.vue
// module id = 2108
// module chunks = 137